import PageWrapper from '@/components/page-wrapper'
import Banner from './banner'
import Matter from './matter'
import Need from './need'
import Integration from './integration'
import Roadmap from './roadmap'
import Advantage from './advantage'
import Contact from './contact'

export default function SchoolBus() {
  return (
    <PageWrapper soul>
      <Banner />
      <Matter />
      <Need />
      <Integration />
      <Roadmap />
      <Advantage />
      <Contact />
    </PageWrapper>
  )
}
